export class InventoryItem {
  productName: string = '';
  productCode: string = '';
  itemDescription: string = ''; // Max 35 chars
  itemCommodityCode: string = '';

  unitCost: number;
  unitCostCashPrice: number;
  unitCostCardPrice: number;
  unitMeasure: string;
  unitMeasureLabel?: string;

  taxRate?: number;
  stateTaxRate: number;
  localTaxRate: number;
  discountRate?: number;
  discountAmount?: number;
  stateTaxAmount?: number;
  localTaxAmount?: number;
  totalTaxAmount?: number;
  taxTypeApplied?: string;
  taxIds: string[]
  createdBy: string;
  merchantEmail: string;
  createdAt: Date;
  updatedAt: Date;
  lastUpdatedBy: string
  storeId: string;
  _id?: string
}

export const ItemMinAndMax = {
  pName: { min: 3, max: 40 }, // using small variables will improve template readabilty
  pCode: { min: 4, max: 25 },
  itemDesc: { min: 3, max: 100 },
  tRate: { min: 0.1, max: 22 },
  dRate: { min: 1, max: 100 },
  uCost: { min: 0 },
  dAmount: { min: 0.1 }
}

export type ItemModalRes = {
  isSave?: boolean,
  isUpdate?: boolean,
}

export type IgetAllInventoryRes = {
  items: InventoryItem[],
  totalCount: number,
  inventory: Inventory,
  inventorySize: number
}

export const inventoryToastMessages = {
  addSuccess: 'Item added successfully',
  updateSuccess: 'Item updated successfully',
  deleteSuccess: 'Item deleted successfully',
  deleteError: 'Error deleting item',
  noItems: 'No items found',
}

export type IinventoryFilterData = {
  data: {
    items: InventoryItem[],
    totalCount: number
  },
  searchTerm: string,
  searchTermName: string
}

export type Inventory = {
  _id: string;
  storeId: string;
  merchantId: string;
  customerId: string;
  pricing?: PricingEntity[];
  currentPricingType: 'CASH' | 'CARD';
  showDualPricing: boolean;
  taxes: TaxEntity[];
  __v: number;
  createdAt: Date;
  updatedAt: Date;
  inventoryEnabled: boolean;
  merchantCanEditMarkup: boolean;
  sortBy?: InventorySortBy;
  sortOptions?: InventorySortOption[];
}
export type InventorySortBy = {
  field: string;
  order: 'ASC' | 'DESC';
}

export type InventorySortOption = {
  value: string;
  label: string;
}
export type PricingEntity = {
  type: 'CASH' | 'CARD';
  isPremium: boolean;
  rate: number;
  _id: string;
}

export type TaxEntity = {
  _id: string;
  name: string;
  rate: number;
  type: 'LOCAL' | 'STATE';
  disabled?: boolean
}


export type InventoryStore = {
  id: string; // storeId
  dba: string;
  email: string;
  inventory: Inventory | null;
  itemDetails: ItemDetails;
}
export type ItemDetails = {
  _id: string; // Store Id
  count: number; // Defaults to 0
}

export enum PricingMode {
  CASH = "CASH",
  CARD = "CARD"
}

export const TaxTypes = {
  State: 'STATE',
  local: 'LOCAL'
}

export type InventorySaveRes = {
  message: string,
  new: boolean,
  inventory: Inventory
}

export type TxInventory = {
  _id: string;
  taxAmount: number;
  totalAmount: number;
  unitMeasure: string;
  discountAmount: number;
  itemCount: number;
  productName: string;
  productCode: string;
  "txInventory_from_store.dba": string;
}



export type IBSPaymentRequest = {
  resultItems: (ResultItemsEntity)[] | null;
  levelInformation: LevelInformation;
}
export type ResultItemsEntity = {
  description: string;
  name: string;
  quantity: number;
  unitMeasure: string;
  cashTotal: number;
  cashDiscountAmount: number;
  cashAmt: number;
  cashBaseItem: number;
  cashTax: number;
  cardTotal: number;
  cardDiscountAmount: number;
  cardAmt: number;
  cardBaseItem: number;
  cardTax: number;
}
export interface LevelInformation {
  baseCardAmount: number;
  baseCashAmount: number;
  cardAmount: number;
  cashAmount: number;
  fee: number;
  localTaxFee: number;
  stateTaxFee: number;
  totalFee: number;
  tax1CardAmount: number;
  tax1CashAmount: number;
  tax1Label: string;
  tax2CardAmount: number;
  tax2CashAmount: number;
  tax2Label: string;
  totalTaxCardAmount: number;
  totalTaxCashAmount: number;
  totalCardAmount: number;
  totalCardDiscount: number;
  totalCashAmount: number;
  totalCashDiscount: number;
  shippingFee: number;
  fixedFeeAmount : number;
}





